import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPermissionCircles = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 345,
	height: 276,
	fill: "none",
	viewBox: "0 0 345 276",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#prefix__filter0_d_3278_50281)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 70.785,
				y: 38.798,
				width: 224.501,
				height: 224.501,
				rx: 112.251,
				fill: "#fff",
				shapeRendering: "crispEdges"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M183.016 80.047l.838.05.419.056.433.093.788.241a7.04 7.04 0 011.541.795l.739.583 1.81 1.547a78.102 78.102 0 0051.043 18.014l2.429-.071a7.097 7.097 0 017.135 5.09 92.309 92.309 0 01-8.249 71.538 92.318 92.318 0 01-24.113 27.722 92.32 92.32 0 01-33.016 16.119 7.104 7.104 0 01-3.565 0 92.31 92.31 0 01-68.524-78.771 92.313 92.313 0 013.139-36.608 7.098 7.098 0 017.136-5.09 78.104 78.104 0 0053.471-17.943l1.867-1.597.682-.533a7.04 7.04 0 011.541-.795l.795-.241c.278-.067.56-.117.845-.15l.816-.05zm.015 49.701a14.203 14.203 0 00-14.165 13.136l-.036 1.065.036 1.065a14.202 14.202 0 007.064 11.225v12.56l.05.831a7.1 7.1 0 0014.151-.831l.007-12.553a14.198 14.198 0 001.54-23.566 14.2 14.2 0 00-8.647-2.932z",
				fill: "url(#prefix__paint0_linear_3278_50281)"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#prefix__filter1_d_3278_50281)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 10,
				y: 57.439,
				width: 81.047,
				height: 81.047,
				rx: 40.524,
				fill: "#fff",
				shapeRendering: "crispEdges"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M34.314 85.805c0 1.613 1.708 3.159 4.748 4.299 3.04 1.14 7.163 1.78 11.462 1.78 4.299 0 8.422-.64 11.462-1.78 3.04-1.14 4.747-2.686 4.747-4.299m-32.419 0c0-1.612 1.708-3.158 4.748-4.298 3.04-1.14 7.163-1.78 11.462-1.78 4.299 0 8.422.64 11.462 1.78 3.04 1.14 4.747 2.686 4.747 4.298m-32.419 0v12.158m32.42-12.157v12.157m-32.42 0c0 1.612 1.708 3.158 4.748 4.298 3.04 1.14 7.163 1.78 11.462 1.78 4.299 0 8.422-.64 11.462-1.78 3.04-1.14 4.747-2.686 4.747-4.298m-32.419 0v12.157c0 1.612 1.708 3.158 4.748 4.298 3.04 1.14 7.163 1.78 11.462 1.78 4.299 0 8.422-.64 11.462-1.78 3.04-1.14 4.747-2.686 4.747-4.298V97.963",
				stroke: "#74674D",
				strokeWidth: 4.052,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#prefix__filter2_d_3278_50281)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 253.953,
				y: 174.147,
				width: 81.047,
				height: 81.047,
				rx: 40.524,
				fill: "#fff",
				shapeRendering: "crispEdges"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M282.319 232.906v-4.052a8.106 8.106 0 018.105-8.105h8.105a8.106 8.106 0 018.104 8.105v4.052m-20.261-28.366a8.105 8.105 0 1016.21.002 8.105 8.105 0 00-16.21-.002z",
				stroke: "#74674D",
				strokeWidth: 4.052,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#prefix__filter3_d_3278_50281)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 225.586,
				y: 8,
				width: 81.047,
				height: 81.047,
				rx: 40.524,
				fill: "#fff",
				shapeRendering: "crispEdges"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M247.874 66.76v-4.053a8.105 8.105 0 018.105-8.105h8.105a8.106 8.106 0 018.104 8.105v4.052m2.027-36.208a8.108 8.108 0 016.094 7.852 8.107 8.107 0 01-6.094 7.851m10.13 20.505v-4.052a8.106 8.106 0 00-6.078-7.801m-26.34-16.513a8.104 8.104 0 1016.208.002 8.104 8.104 0 00-16.208-.002z",
				stroke: "#74674D",
				strokeWidth: 4.052,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "prefix__filter0_d_3278_50281",
				x: 60.81,
				y: 30.818,
				width: 244.451,
				height: 244.451,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.995 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.988 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0.0873 0 0 0 0 0.0658333 0 0 0 0 0.334167 0 0 0 0.08 0" }),
					/* @__PURE__ */ _jsx("feBlend", {
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_3278_50281"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "effect1_dropShadow_3278_50281",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "prefix__filter1_d_3278_50281",
				x: .025,
				y: 49.459,
				width: 100.998,
				height: 100.998,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.995 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.988 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0.0873 0 0 0 0 0.0658333 0 0 0 0 0.334167 0 0 0 0.08 0" }),
					/* @__PURE__ */ _jsx("feBlend", {
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_3278_50281"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "effect1_dropShadow_3278_50281",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "prefix__filter2_d_3278_50281",
				x: 243.978,
				y: 166.167,
				width: 100.997,
				height: 100.998,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.995 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.988 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0.0873 0 0 0 0 0.0658333 0 0 0 0 0.334167 0 0 0 0.08 0" }),
					/* @__PURE__ */ _jsx("feBlend", {
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_3278_50281"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "effect1_dropShadow_3278_50281",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "prefix__filter3_d_3278_50281",
				x: 215.611,
				y: .02,
				width: 100.997,
				height: 100.998,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.995 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.988 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0.0873 0 0 0 0 0.0658333 0 0 0 0 0.334167 0 0 0 0.08 0" }),
					/* @__PURE__ */ _jsx("feBlend", {
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_3278_50281"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "effect1_dropShadow_3278_50281",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "prefix__paint0_linear_3278_50281",
				x1: 125.783,
				y1: 80.272,
				x2: 218.649,
				y2: 221.825,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFC75A" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E29500"
				})]
			})
		] })
	]
});
export default SvgPermissionCircles;
